angular.module('zc.master')
  .component('zcMasterHomeReport', {
    templateUrl: '/templates/master/components/master_home_report/master_home_report.html',
    bindings: {
      projects: '<',
      campaigns: '<',
      filters: '<',
      sortReports: '&'
    },
    controller: zcMasterHomeReport,
  });


zcMasterHomeReport.$inject = ['$scope', 'Devise', 'SearchFilter', 'MasterProject'];
function zcMasterHomeReport($scope, Devise, SearchFilter, MasterProject) {
  const vm = this;

  vm.searchTerm = '';
  vm.filterProjects = filterProjects;
  vm.filterCampaigns = filterCampaigns;
  vm.toggleExpandedReport = toggleExpandedReport;
  vm.toggleFlatReport = toggleFlatReport;
  vm.setColumnReport = setColumnReport;
  vm.toggleAllReport = toggleAllReport;
  vm.sortBy = sortBy;
  vm.star = star;
  vm.unstar = unstar;

  function filterProjects(project) {
    if(!vm.filters.all_report && !project.starred) return false;
    if(vm.searchTerm === '') return true;
    if(project.title.indexOf(vm.searchTerm) >= 0) return true;
    if(project.apikey.indexOf(vm.searchTerm) >= 0) return true;
    return false;
  }

  function filterCampaigns(campaign) {
    if(!vm.filters.all_report && !campaign.project.starred) return false;
    if(vm.searchTerm === '') return true;
    if(campaign.project.title.indexOf(vm.searchTerm) >= 0) return true;
    if(campaign.project.apikey.indexOf(vm.searchTerm) >= 0) return true;
    if(campaign.name && campaign.name.indexOf(vm.searchTerm) >= 0) return true;
    return false;
  }

  function toggleExpandedReport() {
    vm.filters.expanded_report = !vm.filters.expanded_report;
    _.each(vm.projects, project => {
      project.expanded_report = vm.filters.expanded_report;
    });
    SearchFilter.updateComponentDefaults('home');
  }

  function toggleFlatReport() {
    vm.filters.flat_report = !vm.filters.flat_report;
    SearchFilter.updateComponentDefaults('home');
  }

  function setColumnReport(column) {
    vm.filters.column_report = column;
    SearchFilter.updateComponentDefaults('home');
  }

  function toggleAllReport() {
    vm.filters.all_report = !vm.filters.all_report;
    SearchFilter.updateComponentDefaults('home');
  }

  function sortBy(key) {
    if(vm.filters.sort_prop === key) {
      if(vm.filters.sort_direction === 'desc') {
        vm.filters.sort_direction = 'asc';
      } else {
        vm.filters.sort_direction = 'desc';
      }
    } else {
      vm.filters.sort_prop = key;
      vm.filters.sort_direction = 'desc';
    }
    vm.sortReports();
    SearchFilter.updateComponentDefaults('home');
  }

  function star(project) {
    MasterProject.assign({projectId: project.id}, {userId: Devise.currentUser.id}).then(res => {
      if(res.data.success) {
        project.starred = true;
        // In order for the campaign-filter-view to work properly we need propagate this change
        // to the parent scope as well (unless reloading the entire page).
        $scope.$parent.$ctrl.starredApikeyMap[project.apikey] = true;
        $scope.$parent.$ctrl.updateReports();
      }
    });
  }

  function unstar(project) {
    MasterProject.unassign({projectId: project.id}, {userId: Devise.currentUser.id}).then(res => {
      if(res.data.success) {
        project.starred = false;
        // In order for the campaign-filter-view to work properly we need propagate this change
        // to the parent scope as well (unless reloading the entire page).
        $scope.$parent.$ctrl.starredApikeyMap[project.apikey] = false;
        $scope.$parent.$ctrl.updateReports();
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/master_admin_modules/master/components/master_home_report/master_home_report.js